import React from 'react';
import block from "bem-css-modules";
import separate from "../../../styles/components//Utility/Separator.module.scss";

const Separator = function({spaceTop, spaceBottom, label}) {
    block.setSettings({
        modifierDelimiter: "--",
    });

    const line = block(separate);

    return (
        <div className={line('')}>
            <div className={`${line('holder')}` + ' ' + " " + `${spaceTop && line("holder--spaceTop")}` + " " + `${spaceBottom && line("holder--spaceBottom")}`} >
                <div className={`${line('label')}` + ' ' + `${label && line('label--text')}` }>{label}</div>
            </div>
        </div>
    );
            
}

export default Separator;